module.exports = __webpack_public_path__ + "static/img/athlete.4944c0d8.svg";